import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconHelp(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-.749-9.567c-.178.436-.267 1.151-.267 2.146h2.119c0-.725.064-1.237.193-1.538.129-.301.494-.74 1.096-1.317.565-.553.98-1.047 1.244-1.483.264-.436.396-.961.396-1.575 0-1.007-.347-1.87-1.041-2.588C14.297 5.359 13.305 5 12.016 5c-1.044 0-1.91.289-2.598.866C8.731 6.443 8.258 7.125 8 7.91l1.897.81c.136-.393.366-.78.691-1.16.326-.381.802-.572 1.428-.572.601 0 1.071.166 1.409.498.338.331.507.749.507 1.252 0 .418-.132.79-.396 1.115-.264.325-.648.71-1.152 1.151-.577.516-.955.992-1.133 1.428Zm-.276 6.134c.289.289.636.433 1.04.433.406 0 .753-.144 1.042-.433.288-.288.432-.635.432-1.04a1.42 1.42 0 0 0-.432-1.042 1.419 1.419 0 0 0-1.041-.432c-.405 0-.752.144-1.041.432a1.42 1.42 0 0 0-.433 1.041c0 .406.144.753.433 1.041Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
